import React, { useEffect, useRef, useState } from 'react';
import { Typography, Tabs, Progress } from 'antd';


import { Database } from './supabase-types.ts';


import BingoTable from './BingoTable.tsx';
import {FullCard} from './BingoTable.tsx';

const EDGEDB_SECRET_KEY = 'nbwt1_eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9.eyJlZGIuZC5hbGwiOnRydWUsImVkYi5pIjpbInNhZHJ1ZGRpbi9iaW5nbyJdLCJlZGIuci5hbGwiOnRydWUsImlhdCI6MTczNjQzNzgyOCwiaXNzIjoiYXdzLmVkZ2VkYi5jbG91ZCIsImp0aSI6ImN6WkJYczZoRWUtNGpzc1E0ZGpwckEiLCJzdWIiOiJPVkR2S00ycEVlLVQxa2RqVklyaDV3In0.yRMRFSoyAjRTOx2MNSO_6LV-H_9ovSiHRNVdAlZcGSsfKZ4Fy4O1STbq48JAOXTVzLleyPE1AZX43VfjSXbL9A';

const { Title } = Typography;
type Card = Database['public']['Tables']['card']['Row'];
type Goal = Database['public']['Tables']['goal']['Row'];

const getStatusContent = (
  card: FullCard,
  scale: number,
  assignRef?: (el: HTMLDivElement | null) => void
) => {
  const completed = card.goal.map(x => Math.min(x.completion_dates.length/(x.quantity || 1), 1)) as number[];
  const percent = Math.round(100.0*completed.reduce((a, b) => a+b, 0)/(card.size*card.size));
  return <div
    ref={assignRef}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      gap: 8,
      transform: `scale(${scale})`,
      transformOrigin: 'center',
    }}
  >
    <Progress percent={percent} size='small' type="circle" />
    <span style={{ lineHeight: 1.2, fontSize: 32, textAlign: 'center', whiteSpace: 'nowrap' }}>{card.title}</span>
  </div>

}

const BingoPage = (props) => {
  const {supabase} = props;
  const [data, setData] = useState<FullCard[]>([]);
  const [selected, setSelected] = useState<string>('');

  const fetchData = async () => {
    const { data, error } = await supabase
    .from('card')
    .select('*,goal(*)')
    .order('order', { ascending: true, foreignTable: 'goal' })

  if (error) {
    console.error('Error:', error);
  } else {
    console.log('Data:', data);
  }
  setData(data);

}
  useEffect(() => {fetchData()}, []);  
  const containerRef = useRef<HTMLDivElement | null>(null);
  const labelRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [labelScale, setLabelScale] = useState<number>(1);

  useEffect(() => {
    const computeScale = () => {
      if (!containerRef.current || data.length === 0) {
        setLabelScale(1);
        return;
      }

      const containerWidth = containerRef.current.clientWidth || window.innerWidth;
      const tabCount = Math.max(1, data.length);
      const gapPerTab = 8; // must match CSS column-gap
      const horizontalPadding = 24; // estimated total padding per tab button

      const perTabAvailableWidth = Math.max(
        0,
        (containerWidth - (tabCount - 1) * gapPerTab - horizontalPadding) / tabCount
      );

      // Measure widest label content at natural size (scale=1)
      const maxLabelWidth = Math.max(
        0,
        ...labelRefs.current.map(el => (el ? Math.max(el.scrollWidth, el.offsetWidth) : 0))
      );

      if (maxLabelWidth === 0) {
        setLabelScale(1);
        return;
      }

      const scale = Math.min(1, 0.8 * perTabAvailableWidth / maxLabelWidth);
      setLabelScale(scale);
    };

    // Compute after render
    computeScale();
    const onResize = () => computeScale();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [data]);

    return <div ref={containerRef}>
      <Tabs
        defaultActiveKey={data.length && data[0].title || ''}
        size='large'
        items={data.map((card, i) => {
          return {
            label: getStatusContent(card, labelScale, (el) => { labelRefs.current[i] = el; }),
            key: card.title || '',
            children: <BingoTable supabase={supabase} card={card} onRefresh={fetchData}/>,
          };
        })}
      />
    </div>;

};

export default BingoPage;